import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import Title from '../../../../components/Title/Title';
import { Col, Divider, Row } from 'antd';
import CustomInput from '../../../../components/CustomInput/CustomInput';
import FlexWrapper from '../../../../components/FlexWrapper/FlexWrapper';
import { useDispatch, useSelector } from 'react-redux';
import {
    getStandartTimings,
    timingsLoadingStatus,
    storeStandartTimings,
} from '../../../../redux/slices/communicationSlice';
import LocalLoader from '../../../../components/LocalLoader/LocalLoader';
import Spacer from '../../../../components/Spacer';
import { toast } from 'react-toastify';
import CustomSelect from '../../../../components/CustomSelect/CustomSelect';
import { Plus, Trash } from '../../../../components/Svg/Svg';
import { remindersSelectOptions, standartTimings } from './data';
import { createShallowCopy } from '../../../../utils/helpFunctions';

export default function UserCommunicationTimingsPage() {
    const dispatch = useDispatch();
    const timingsLoading = useSelector(timingsLoadingStatus);
    const [data, setData] = useState([]);

    const getTimingsAll = useCallback(async () => {
        const response = await dispatch(getStandartTimings()).unwrap();

        if (!response.length) {
            setData(standartTimings);
        } else {
            const communicationTypes = ['email', 'phone', 'email_and_phone'];
            let merged = [...response];

            communicationTypes.forEach((type) => {
                const hasType = response.some(
                    (el) => el.communication_type === type,
                );
                if (!hasType) {
                    const defaults = standartTimings.filter(
                        (el) => el.communication_type === type,
                    );
                    merged = [...merged, ...defaults];
                }
            });

            setData(merged);
        }
    }, [dispatch]);

    useEffect(() => {
        getTimingsAll();
    }, [getTimingsAll]);

    const onChangeRemindersDay = (e) => {
        const { id, value } = e.target;
        const dataCopy = createShallowCopy(data);
        const reminderIndex = dataCopy.findIndex((el) => el.name === id);

        dataCopy[reminderIndex].day = Number(value);

        setData(dataCopy);
    };

    const onSelectChange = (option, reminderName, idx) => {
        const dataCopy = createShallowCopy(data);
        const reminderIndex = dataCopy.findIndex(
            (el) => el.name === reminderName,
        );

        dataCopy[reminderIndex].template_priority[idx] = option.value;

        setData(dataCopy);
    };

    const onDeleteReminder = (reminderName, idx) => {
        const dataCopy = createShallowCopy(data);
        const reminderIndex = dataCopy.findIndex(
            (el) => el.name === reminderName,
        );

        dataCopy[reminderIndex].template_priority.splice(idx, 1);

        setData(dataCopy);
    };

    const onAddReminder = (reminderName, idx) => {
        const dataCopy = createShallowCopy(data);
        const reminderIndex = dataCopy.findIndex(
            (el) => el.name === reminderName,
        );

        const hasEmailTiming = dataCopy[reminderIndex].template_priority.some(
            (el) => el.includes('email'),
        );

        if (hasEmailTiming) {
            dataCopy[reminderIndex].template_priority.push(
                'welcome_reminder_sms_1',
            );
        } else {
            dataCopy[reminderIndex].template_priority.push(
                'welcome_reminder_email_1',
            );
        }

        setData(dataCopy);
    };

    const onSubmitTimings = async () => {
        try {
            await dispatch(storeStandartTimings({ timings: data })).unwrap();
            getTimingsAll();
            toast.success('Changes saved successfully');
        } catch (error) {
            console.log(error);
        }
    };

    const emailFlowReminders = data?.filter(
        (el) => el.communication_type === 'email',
    );
    const smsFlowReminders = data?.filter(
        (el) => el.communication_type === 'phone',
    );
    const emailAndPhoneFlowReminders = data?.filter(
        (el) => el.communication_type === 'email_and_phone',
    );

    return (
        <div>
            <Helmet>
                <title>Console Defentry - User communication - Timings</title>
            </Helmet>
            <Title
                subText="Welcome reminders timings for user communication"
                isSubPageTitle
            >
                Timings
            </Title>
            <LocalLoader size={30} isLoading={timingsLoading === 'loading'}>
                <div className="details-table-wrapper">
                    <div className="table-top-pannel">
                        <div className="table-top-pannel__info">
                            <h2 className="table-top-pannel__title">
                                Email flow
                            </h2>
                        </div>
                    </div>

                    {emailFlowReminders?.map((reminder, idx) => {
                        const reminderIndex = data.findIndex(
                            (el) => el.name === reminder.name,
                        );
                        return (
                            <div key={idx}>
                                <Row gutter={[48, 0]}>
                                    <Col span={12}>
                                        <label
                                            className="input-label"
                                            style={{ marginBottom: '16px' }}
                                        >
                                            Send out day
                                        </label>
                                        <CustomInput
                                            className="ant-input ant-input-lg"
                                            id={reminder.name}
                                            placeholder="Enter amount of days after registration"
                                            onInputChange={onChangeRemindersDay}
                                            inputValue={data[
                                                reminderIndex
                                            ].day.toString()}
                                            width="100%"
                                        />
                                    </Col>
                                    <Col span={12}>
                                        <label
                                            className="input-label"
                                            style={{ marginBottom: '16px' }}
                                        >
                                            Prio order
                                        </label>
                                        {reminder.template_priority.map(
                                            (priority, i) => {
                                                const emailOpts =
                                                    remindersSelectOptions.slice(
                                                        0,
                                                        3,
                                                    );
                                                const smsOpts =
                                                    remindersSelectOptions.slice(
                                                        3,
                                                    );
                                                const priorityTemplateId =
                                                    priority.includes('email')
                                                        ? Number(
                                                              priority.slice(
                                                                  -1,
                                                              ),
                                                          )
                                                        : Number(
                                                              priority.slice(
                                                                  -1,
                                                              ),
                                                          ) + 3;
                                                const opts =
                                                    reminder.template_priority
                                                        .length < 2
                                                        ? remindersSelectOptions
                                                        : (priorityTemplateId <
                                                              4 &&
                                                              emailOpts) ||
                                                          smsOpts;
                                                return (
                                                    <div key={i}>
                                                        <FlexWrapper>
                                                            <div
                                                                style={{
                                                                    flexGrow: 1,
                                                                }}
                                                            >
                                                                <CustomSelect
                                                                    name="email"
                                                                    onChange={(
                                                                        option,
                                                                    ) =>
                                                                        onSelectChange(
                                                                            option,
                                                                            reminder.name,
                                                                            i,
                                                                        )
                                                                    }
                                                                    options={
                                                                        opts
                                                                    }
                                                                    placeholder="Select reminder"
                                                                    value={
                                                                        priorityTemplateId
                                                                    }
                                                                />
                                                            </div>
                                                            {reminder
                                                                .template_priority
                                                                .length > 1 ? (
                                                                <>
                                                                    <Spacer
                                                                        orientation="vertical"
                                                                        size={8}
                                                                    />
                                                                    <FlexWrapper align="center">
                                                                        <button
                                                                            className="form__trash-button"
                                                                            name="big-logo"
                                                                            onClick={() =>
                                                                                onDeleteReminder(
                                                                                    reminder.name,
                                                                                    i,
                                                                                )
                                                                            }
                                                                        >
                                                                            <FlexWrapper
                                                                                align="center"
                                                                                justify="center"
                                                                            >
                                                                                <Trash />
                                                                            </FlexWrapper>
                                                                        </button>
                                                                    </FlexWrapper>
                                                                </>
                                                            ) : reminder
                                                                  .template_priority
                                                                  .length ===
                                                                  1 &&
                                                              i === 0 ? (
                                                                <div></div>
                                                            ) : (
                                                                <div
                                                                    style={{
                                                                        width: '32px',
                                                                        height: '32px',
                                                                        marginLeft:
                                                                            '16px',
                                                                    }}
                                                                ></div>
                                                            )}
                                                        </FlexWrapper>
                                                        <Spacer size={8} />
                                                    </div>
                                                );
                                            },
                                        )}
                                        <button
                                            className="modal__button modal__button-cancel"
                                            style={{ width: '100%' }}
                                            onClick={() =>
                                                onAddReminder(reminder.name)
                                            }
                                            disabled={
                                                reminder?.template_priority
                                                    ?.length > 1
                                            }
                                        >
                                            <FlexWrapper
                                                align="center"
                                                justify="center"
                                            >
                                                <Plus />
                                                &nbsp;&nbsp;Add reminder
                                            </FlexWrapper>
                                        </button>
                                    </Col>
                                </Row>
                                <Divider />
                            </div>
                        );
                    })}
                </div>
                <Spacer size={16} />
                <div className="details-table-wrapper">
                    <div className="table-top-pannel">
                        <div className="table-top-pannel__info">
                            <h2 className="table-top-pannel__title">
                                Sms flow
                            </h2>
                        </div>
                    </div>

                    {smsFlowReminders?.map((reminder, idx) => {
                        const reminderIndex = data.findIndex(
                            (el) => el.name === reminder.name,
                        );
                        return (
                            <div key={idx}>
                                <Row gutter={[48, 0]}>
                                    <Col span={12}>
                                        <label
                                            className="input-label"
                                            style={{ marginBottom: '16px' }}
                                        >
                                            Send out day
                                        </label>
                                        <CustomInput
                                            className="ant-input ant-input-lg"
                                            id={reminder.name}
                                            placeholder="Enter amount of days after registration"
                                            onInputChange={onChangeRemindersDay}
                                            inputValue={data[
                                                reminderIndex
                                            ].day.toString()}
                                            width="100%"
                                        />
                                    </Col>
                                    <Col span={12}>
                                        <label
                                            className="input-label"
                                            style={{ marginBottom: '16px' }}
                                        >
                                            Prio order
                                        </label>
                                        {reminder.template_priority.map(
                                            (priority, i) => {
                                                const emailOpts =
                                                    remindersSelectOptions.slice(
                                                        0,
                                                        3,
                                                    );
                                                const smsOpts =
                                                    remindersSelectOptions.slice(
                                                        3,
                                                    );
                                                const priorityTemplateId =
                                                    priority.includes('email')
                                                        ? Number(
                                                              priority.slice(
                                                                  -1,
                                                              ),
                                                          )
                                                        : Number(
                                                              priority.slice(
                                                                  -1,
                                                              ),
                                                          ) + 3;
                                                const opts =
                                                    reminder.template_priority
                                                        .length < 2
                                                        ? remindersSelectOptions
                                                        : (priorityTemplateId <
                                                              4 &&
                                                              emailOpts) ||
                                                          smsOpts;
                                                return (
                                                    <div key={i}>
                                                        <FlexWrapper>
                                                            <div
                                                                style={{
                                                                    flexGrow: 1,
                                                                }}
                                                            >
                                                                <CustomSelect
                                                                    name="email"
                                                                    onChange={(
                                                                        option,
                                                                    ) =>
                                                                        onSelectChange(
                                                                            option,
                                                                            reminder.name,
                                                                            i,
                                                                        )
                                                                    }
                                                                    options={
                                                                        opts
                                                                    }
                                                                    placeholder="Select reminder"
                                                                    value={
                                                                        priorityTemplateId
                                                                    }
                                                                />
                                                            </div>
                                                            {reminder
                                                                .template_priority
                                                                .length > 1 ? (
                                                                <>
                                                                    <Spacer
                                                                        orientation="vertical"
                                                                        size={8}
                                                                    />
                                                                    <FlexWrapper align="center">
                                                                        <button
                                                                            className="form__trash-button"
                                                                            name="big-logo"
                                                                            onClick={() =>
                                                                                onDeleteReminder(
                                                                                    reminder.name,
                                                                                    i,
                                                                                )
                                                                            }
                                                                        >
                                                                            <FlexWrapper
                                                                                align="center"
                                                                                justify="center"
                                                                            >
                                                                                <Trash />
                                                                            </FlexWrapper>
                                                                        </button>
                                                                    </FlexWrapper>
                                                                </>
                                                            ) : reminder
                                                                  .template_priority
                                                                  .length ===
                                                                  1 &&
                                                              i === 0 ? (
                                                                <div></div>
                                                            ) : (
                                                                <div
                                                                    style={{
                                                                        width: '32px',
                                                                        height: '32px',
                                                                        marginLeft:
                                                                            '16px',
                                                                    }}
                                                                ></div>
                                                            )}
                                                        </FlexWrapper>
                                                        <Spacer size={8} />
                                                    </div>
                                                );
                                            },
                                        )}
                                        <button
                                            className="modal__button modal__button-cancel"
                                            style={{ width: '100%' }}
                                            onClick={() =>
                                                onAddReminder(reminder.name)
                                            }
                                            disabled={
                                                reminder?.template_priority
                                                    ?.length > 1
                                            }
                                        >
                                            <FlexWrapper
                                                align="center"
                                                justify="center"
                                            >
                                                <Plus />
                                                &nbsp;&nbsp;Add reminder
                                            </FlexWrapper>
                                        </button>
                                    </Col>
                                </Row>
                                <Divider />
                            </div>
                        );
                    })}
                </div>
                <Spacer size={16} />
                <div className="details-table-wrapper">
                    <div className="table-top-pannel">
                        <div className="table-top-pannel__info">
                            <h2 className="table-top-pannel__title">
                                Email and Phone flow
                            </h2>
                        </div>
                    </div>

                    {emailAndPhoneFlowReminders?.map((reminder, idx) => {
                        const reminderIndex = data.findIndex(
                            (el) => el.name === reminder.name,
                        );
                        return (
                            <div key={idx}>
                                <Row gutter={[48, 0]}>
                                    <Col span={12}>
                                        <label
                                            className="input-label"
                                            style={{ marginBottom: '16px' }}
                                        >
                                            Send out day
                                        </label>
                                        <CustomInput
                                            className="ant-input ant-input-lg"
                                            id={reminder.name}
                                            placeholder="Enter amount of days after registration"
                                            onInputChange={onChangeRemindersDay}
                                            inputValue={data[
                                                reminderIndex
                                            ].day.toString()}
                                            width="100%"
                                        />
                                    </Col>
                                    <Col span={12}>
                                        <label
                                            className="input-label"
                                            style={{ marginBottom: '16px' }}
                                        >
                                            Prio order
                                        </label>
                                        {reminder.template_priority.map(
                                            (priority, i) => {
                                                const emailOpts =
                                                    remindersSelectOptions.slice(
                                                        0,
                                                        3,
                                                    );
                                                const smsOpts =
                                                    remindersSelectOptions.slice(
                                                        3,
                                                    );
                                                const priorityTemplateId =
                                                    priority.includes('email')
                                                        ? Number(
                                                              priority.slice(
                                                                  -1,
                                                              ),
                                                          )
                                                        : Number(
                                                              priority.slice(
                                                                  -1,
                                                              ),
                                                          ) + 3;
                                                const opts =
                                                    reminder.template_priority
                                                        .length < 2
                                                        ? remindersSelectOptions
                                                        : (priorityTemplateId <
                                                              4 &&
                                                              emailOpts) ||
                                                          smsOpts;
                                                return (
                                                    <div key={i}>
                                                        <FlexWrapper>
                                                            <div
                                                                style={{
                                                                    flexGrow: 1,
                                                                }}
                                                            >
                                                                <CustomSelect
                                                                    name="email"
                                                                    onChange={(
                                                                        option,
                                                                    ) =>
                                                                        onSelectChange(
                                                                            option,
                                                                            reminder.name,
                                                                            i,
                                                                        )
                                                                    }
                                                                    options={
                                                                        opts
                                                                    }
                                                                    placeholder="Select reminder"
                                                                    value={
                                                                        priorityTemplateId
                                                                    }
                                                                />
                                                            </div>
                                                            {reminder
                                                                .template_priority
                                                                .length > 1 ? (
                                                                <>
                                                                    <Spacer
                                                                        orientation="vertical"
                                                                        size={8}
                                                                    />
                                                                    <FlexWrapper align="center">
                                                                        <button
                                                                            className="form__trash-button"
                                                                            name="big-logo"
                                                                            onClick={() =>
                                                                                onDeleteReminder(
                                                                                    reminder.name,
                                                                                    i,
                                                                                )
                                                                            }
                                                                        >
                                                                            <FlexWrapper
                                                                                align="center"
                                                                                justify="center"
                                                                            >
                                                                                <Trash />
                                                                            </FlexWrapper>
                                                                        </button>
                                                                    </FlexWrapper>
                                                                </>
                                                            ) : reminder
                                                                  .template_priority
                                                                  .length ===
                                                                  1 &&
                                                              i === 0 ? (
                                                                <div></div>
                                                            ) : (
                                                                <div
                                                                    style={{
                                                                        width: '32px',
                                                                        height: '32px',
                                                                        marginLeft:
                                                                            '16px',
                                                                    }}
                                                                ></div>
                                                            )}
                                                        </FlexWrapper>
                                                        <Spacer size={8} />
                                                    </div>
                                                );
                                            },
                                        )}
                                        <button
                                            className="modal__button modal__button-cancel"
                                            style={{ width: '100%' }}
                                            onClick={() =>
                                                onAddReminder(reminder.name)
                                            }
                                            disabled={
                                                reminder?.template_priority
                                                    ?.length > 1
                                            }
                                        >
                                            <FlexWrapper
                                                align="center"
                                                justify="center"
                                            >
                                                <Plus />
                                                &nbsp;&nbsp;Add reminder
                                            </FlexWrapper>
                                        </button>
                                    </Col>
                                </Row>
                                <Divider />
                            </div>
                        );
                    })}
                </div>
                <div className="form__footer">
                    <button
                        className="modal__button modal__button-accept"
                        type="button"
                        onClick={onSubmitTimings}
                    >
                        Save
                    </button>
                </div>
            </LocalLoader>
        </div>
    );
}
